import React from "react"
import InfiniteScroll from "react-infinite-scroll-component"

const InfScroll = ({ children, count, next, hasMore, target }) => {
  return (
    <InfiniteScroll
      dataLength={count}
      next={next}
      hasMore={hasMore}
      loader={<h4>Loading...</h4>}
      scrollableTarget={target}
    >
      {children}
    </InfiniteScroll>
  )
}

export default InfScroll
